import { InlineWarning } from '@driftt/tide-core-legacy'
import { withRouter } from 'react-router'

import CalendarSettingsPage from '../page'

import GoogleOAuthConnect from '../GoogleOAuthConnect'
import MicrosoftOAuthConnect from '../MicrosoftOAuthConnect'

import googleGSrc from 'images/onboarding/google-G-logo_L.svg'
import outlookSrc from 'images/logos/office-365.svg'
import 'styles/components/settings/Settings.styl'

const CalendarConnect = ({ googlePermissionError, setGooglePermissionErrorState }) => {
  return (
    <CalendarSettingsPage>
      <div className="subsection">
        <div className="subheader select-calendar select-calendar-text">Connected Calendar</div>
        <div className="settings-body-copy select-calendar">
          Select which calendar you’d like us to connect with. We’ll check for any conflicts when new meetings
          are being scheduled, and add new calendar events to it.
        </div>
        {googlePermissionError && <InlineWarning
          title="Refresh your Google app permissions"
          copy={<span>To re-connect your calendar, go to your <a
            onClick={() => setGooglePermissionErrorState(false)}
            href="https://myaccount.google.com/permissions"
            target="_blank"
            rel="noopener noreferrer"
          >Google app permissions</a>, open the Drift section and click "Remove access". Then come back here to re-connect your calendar!</span>}
          buttonText="Manage Google Apps"
          onClick={() => {
            window.open('https://myaccount.google.com/permissions', '_blank')
            setGooglePermissionErrorState(false)
          }}
          className="google-app-permission-error"
        >
        </InlineWarning>}
        {!googlePermissionError && (
          <div className="setttings-calendar-connection-choices">
            <div className="settings-calendar-connection-choice">
              <img src={googleGSrc} alt="Google logo" />
              <div>Google Calendar</div>
              <GoogleOAuthConnect minimalUI={true} isMissingScopes={true} setGooglePermissionErrorState={setGooglePermissionErrorState} />
            </div>
            <div className="settings-calendar-connection-choice">
              <img src={outlookSrc} alt="Outlook 365 logo" />
              <div>Office 365 Calendar</div>
              <MicrosoftOAuthConnect minimalUI={true} />
            </div>
          </div>
        )}
        <div className="assistant-footer">
          <div className="subheader select-calendar">When you connect your calendar, you’ll also get your own Drift Assistant</div>
          <p className="settings-body-copy assistant-helper-copy">
            The{' '}
            <a
              href="https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work"
              target="_blank"
              rel="noreferrer noopener"
            >
              Drift Assistant
            </a>{' '}
            helps you close more deals with less work. It prepares you for meetings and sends reminders so you never accidentally lose a lead or opportunity again.{' '}
            <a href="https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work" target="_blank" rel="noreferrer noopener">Learn more</a>
          </p>
        </div>
      </div>
    </CalendarSettingsPage>
  )
}

export default withRouter(CalendarConnect)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarConnect/PickOauthComponent.js